export default {
  setCategoryList(state, val) {
  	let initArray = [{
        ID:'0',
        nameHk:'全部商品',
        nameCn:'全部商品',
        nameEn:'All Products',
      },
      ];

      let listArray = [
      ...initArray,
      ...Array.from(val.list)
      ];

    state.categoryList = listArray;
  },
  setKOLProducts(state,val){
  	state.KOLProducts = Array.from(val.list);
  },
  setKOLPackages(state,val){
  	state.KOLPackages = Array.from(val.list);
  },
    setCopyData(state,val){
      state.copyData = val.copyData;
    }

}



// WEBPACK FOOTER //
// ./src/Shop/store/mutations.js